
URL = globalThis.URL
import __vite__wasmUrl from "/app/node_modules/.pnpm/@emurgo+cardano-message-signing-browser@1.0.1/node_modules/@emurgo/cardano-message-signing-browser/cardano_message_signing_bg.wasm?url"
import __vite__initWasm from "/__vite-plugin-wasm-helper"

import { __wbindgen_object_drop_ref as __vite__wasmImport_0_0, __wbindgen_string_new as __vite__wasmImport_0_1, __wbindgen_debug_string as __vite__wasmImport_0_2, __wbindgen_throw as __vite__wasmImport_0_3, __wbindgen_rethrow as __vite__wasmImport_0_4 } from "./cardano_message_signing_bg.js";
const __vite__wasmModule = await __vite__initWasm({ "./cardano_message_signing_bg.js": { __wbindgen_object_drop_ref: __vite__wasmImport_0_0, __wbindgen_string_new: __vite__wasmImport_0_1, __wbindgen_debug_string: __vite__wasmImport_0_2, __wbindgen_throw: __vite__wasmImport_0_3, __wbindgen_rethrow: __vite__wasmImport_0_4 } }, __vite__wasmUrl);
export const memory = __vite__wasmModule.memory;
export const __wbg_protectedheadermap_free = __vite__wasmModule.__wbg_protectedheadermap_free;
export const protectedheadermap_to_bytes = __vite__wasmModule.protectedheadermap_to_bytes;
export const protectedheadermap_from_bytes = __vite__wasmModule.protectedheadermap_from_bytes;
export const protectedheadermap_new_empty = __vite__wasmModule.protectedheadermap_new_empty;
export const protectedheadermap_new = __vite__wasmModule.protectedheadermap_new;
export const protectedheadermap_deserialized_headers = __vite__wasmModule.protectedheadermap_deserialized_headers;
export const __wbg_label_free = __vite__wasmModule.__wbg_label_free;
export const label_to_bytes = __vite__wasmModule.label_to_bytes;
export const label_from_bytes = __vite__wasmModule.label_from_bytes;
export const label_new_int = __vite__wasmModule.label_new_int;
export const label_new_text = __vite__wasmModule.label_new_text;
export const label_kind = __vite__wasmModule.label_kind;
export const label_as_int = __vite__wasmModule.label_as_int;
export const label_as_text = __vite__wasmModule.label_as_text;
export const label_from_algorithm_id = __vite__wasmModule.label_from_algorithm_id;
export const label_from_key_type = __vite__wasmModule.label_from_key_type;
export const label_from_ec_key = __vite__wasmModule.label_from_ec_key;
export const label_from_curve_type = __vite__wasmModule.label_from_curve_type;
export const label_from_key_operation = __vite__wasmModule.label_from_key_operation;
export const __wbg_labels_free = __vite__wasmModule.__wbg_labels_free;
export const labels_to_bytes = __vite__wasmModule.labels_to_bytes;
export const labels_from_bytes = __vite__wasmModule.labels_from_bytes;
export const labels_get = __vite__wasmModule.labels_get;
export const labels_add = __vite__wasmModule.labels_add;
export const __wbg_cosesignatures_free = __vite__wasmModule.__wbg_cosesignatures_free;
export const cosesignatures_to_bytes = __vite__wasmModule.cosesignatures_to_bytes;
export const cosesignatures_from_bytes = __vite__wasmModule.cosesignatures_from_bytes;
export const cosesignatures_get = __vite__wasmModule.cosesignatures_get;
export const cosesignatures_add = __vite__wasmModule.cosesignatures_add;
export const countersignature_to_bytes = __vite__wasmModule.countersignature_to_bytes;
export const countersignature_from_bytes = __vite__wasmModule.countersignature_from_bytes;
export const countersignature_new_single = __vite__wasmModule.countersignature_new_single;
export const countersignature_new_multi = __vite__wasmModule.countersignature_new_multi;
export const countersignature_signatures = __vite__wasmModule.countersignature_signatures;
export const __wbg_headermap_free = __vite__wasmModule.__wbg_headermap_free;
export const headermap_to_bytes = __vite__wasmModule.headermap_to_bytes;
export const headermap_from_bytes = __vite__wasmModule.headermap_from_bytes;
export const headermap_set_algorithm_id = __vite__wasmModule.headermap_set_algorithm_id;
export const headermap_algorithm_id = __vite__wasmModule.headermap_algorithm_id;
export const headermap_set_criticality = __vite__wasmModule.headermap_set_criticality;
export const headermap_criticality = __vite__wasmModule.headermap_criticality;
export const headermap_set_key_id = __vite__wasmModule.headermap_set_key_id;
export const headermap_key_id = __vite__wasmModule.headermap_key_id;
export const headermap_set_partial_init_vector = __vite__wasmModule.headermap_set_partial_init_vector;
export const headermap_partial_init_vector = __vite__wasmModule.headermap_partial_init_vector;
export const headermap_set_counter_signature = __vite__wasmModule.headermap_set_counter_signature;
export const headermap_counter_signature = __vite__wasmModule.headermap_counter_signature;
export const headermap_header = __vite__wasmModule.headermap_header;
export const headermap_set_header = __vite__wasmModule.headermap_set_header;
export const headermap_keys = __vite__wasmModule.headermap_keys;
export const headermap_new = __vite__wasmModule.headermap_new;
export const __wbg_headers_free = __vite__wasmModule.__wbg_headers_free;
export const headers_to_bytes = __vite__wasmModule.headers_to_bytes;
export const headers_from_bytes = __vite__wasmModule.headers_from_bytes;
export const headers_protected = __vite__wasmModule.headers_protected;
export const headers_unprotected = __vite__wasmModule.headers_unprotected;
export const headers_new = __vite__wasmModule.headers_new;
export const __wbg_cosesignature_free = __vite__wasmModule.__wbg_cosesignature_free;
export const cosesignature_to_bytes = __vite__wasmModule.cosesignature_to_bytes;
export const cosesignature_from_bytes = __vite__wasmModule.cosesignature_from_bytes;
export const cosesignature_signature = __vite__wasmModule.cosesignature_signature;
export const cosesignature_new = __vite__wasmModule.cosesignature_new;
export const __wbg_cosesign1_free = __vite__wasmModule.__wbg_cosesign1_free;
export const cosesign1_to_bytes = __vite__wasmModule.cosesign1_to_bytes;
export const cosesign1_from_bytes = __vite__wasmModule.cosesign1_from_bytes;
export const cosesign1_signature = __vite__wasmModule.cosesign1_signature;
export const cosesign1_signed_data = __vite__wasmModule.cosesign1_signed_data;
export const cosesign1_new = __vite__wasmModule.cosesign1_new;
export const __wbg_cosesign_free = __vite__wasmModule.__wbg_cosesign_free;
export const cosesign_to_bytes = __vite__wasmModule.cosesign_to_bytes;
export const cosesign_from_bytes = __vite__wasmModule.cosesign_from_bytes;
export const cosesign_signatures = __vite__wasmModule.cosesign_signatures;
export const cosesign_new = __vite__wasmModule.cosesign_new;
export const __wbg_signedmessage_free = __vite__wasmModule.__wbg_signedmessage_free;
export const signedmessage_to_bytes = __vite__wasmModule.signedmessage_to_bytes;
export const signedmessage_from_bytes = __vite__wasmModule.signedmessage_from_bytes;
export const signedmessage_new_cose_sign = __vite__wasmModule.signedmessage_new_cose_sign;
export const signedmessage_new_cose_sign1 = __vite__wasmModule.signedmessage_new_cose_sign1;
export const signedmessage_from_user_facing_encoding = __vite__wasmModule.signedmessage_from_user_facing_encoding;
export const signedmessage_to_user_facing_encoding = __vite__wasmModule.signedmessage_to_user_facing_encoding;
export const signedmessage_kind = __vite__wasmModule.signedmessage_kind;
export const signedmessage_as_cose_sign = __vite__wasmModule.signedmessage_as_cose_sign;
export const signedmessage_as_cose_sign1 = __vite__wasmModule.signedmessage_as_cose_sign1;
export const __wbg_sigstructure_free = __vite__wasmModule.__wbg_sigstructure_free;
export const sigstructure_to_bytes = __vite__wasmModule.sigstructure_to_bytes;
export const sigstructure_from_bytes = __vite__wasmModule.sigstructure_from_bytes;
export const sigstructure_context = __vite__wasmModule.sigstructure_context;
export const sigstructure_body_protected = __vite__wasmModule.sigstructure_body_protected;
export const sigstructure_sign_protected = __vite__wasmModule.sigstructure_sign_protected;
export const sigstructure_external_aad = __vite__wasmModule.sigstructure_external_aad;
export const sigstructure_payload = __vite__wasmModule.sigstructure_payload;
export const sigstructure_set_sign_protected = __vite__wasmModule.sigstructure_set_sign_protected;
export const sigstructure_new = __vite__wasmModule.sigstructure_new;
export const __wbg_coseencrypt0_free = __vite__wasmModule.__wbg_coseencrypt0_free;
export const coseencrypt0_to_bytes = __vite__wasmModule.coseencrypt0_to_bytes;
export const coseencrypt0_from_bytes = __vite__wasmModule.coseencrypt0_from_bytes;
export const coseencrypt0_headers = __vite__wasmModule.coseencrypt0_headers;
export const coseencrypt0_ciphertext = __vite__wasmModule.coseencrypt0_ciphertext;
export const coseencrypt0_new = __vite__wasmModule.coseencrypt0_new;
export const __wbg_passwordencryption_free = __vite__wasmModule.__wbg_passwordencryption_free;
export const passwordencryption_to_bytes = __vite__wasmModule.passwordencryption_to_bytes;
export const passwordencryption_from_bytes = __vite__wasmModule.passwordencryption_from_bytes;
export const passwordencryption_new = __vite__wasmModule.passwordencryption_new;
export const __wbg_coserecipients_free = __vite__wasmModule.__wbg_coserecipients_free;
export const coserecipients_to_bytes = __vite__wasmModule.coserecipients_to_bytes;
export const coserecipients_from_bytes = __vite__wasmModule.coserecipients_from_bytes;
export const coserecipients_new = __vite__wasmModule.coserecipients_new;
export const coserecipients_len = __vite__wasmModule.coserecipients_len;
export const coserecipients_get = __vite__wasmModule.coserecipients_get;
export const coserecipients_add = __vite__wasmModule.coserecipients_add;
export const __wbg_coseencrypt_free = __vite__wasmModule.__wbg_coseencrypt_free;
export const coseencrypt_to_bytes = __vite__wasmModule.coseencrypt_to_bytes;
export const coseencrypt_from_bytes = __vite__wasmModule.coseencrypt_from_bytes;
export const coseencrypt_recipients = __vite__wasmModule.coseencrypt_recipients;
export const coseencrypt_new = __vite__wasmModule.coseencrypt_new;
export const coserecipient_to_bytes = __vite__wasmModule.coserecipient_to_bytes;
export const coserecipient_from_bytes = __vite__wasmModule.coserecipient_from_bytes;
export const __wbg_pubkeyencryption_free = __vite__wasmModule.__wbg_pubkeyencryption_free;
export const pubkeyencryption_to_bytes = __vite__wasmModule.pubkeyencryption_to_bytes;
export const pubkeyencryption_from_bytes = __vite__wasmModule.pubkeyencryption_from_bytes;
export const pubkeyencryption_new = __vite__wasmModule.pubkeyencryption_new;
export const __wbg_cosekey_free = __vite__wasmModule.__wbg_cosekey_free;
export const cosekey_to_bytes = __vite__wasmModule.cosekey_to_bytes;
export const cosekey_from_bytes = __vite__wasmModule.cosekey_from_bytes;
export const cosekey_set_key_type = __vite__wasmModule.cosekey_set_key_type;
export const cosekey_key_type = __vite__wasmModule.cosekey_key_type;
export const cosekey_set_key_id = __vite__wasmModule.cosekey_set_key_id;
export const cosekey_key_id = __vite__wasmModule.cosekey_key_id;
export const cosekey_set_algorithm_id = __vite__wasmModule.cosekey_set_algorithm_id;
export const cosekey_algorithm_id = __vite__wasmModule.cosekey_algorithm_id;
export const cosekey_set_key_ops = __vite__wasmModule.cosekey_set_key_ops;
export const cosekey_key_ops = __vite__wasmModule.cosekey_key_ops;
export const cosekey_set_base_init_vector = __vite__wasmModule.cosekey_set_base_init_vector;
export const cosekey_base_init_vector = __vite__wasmModule.cosekey_base_init_vector;
export const cosekey_header = __vite__wasmModule.cosekey_header;
export const cosekey_set_header = __vite__wasmModule.cosekey_set_header;
export const cosekey_new = __vite__wasmModule.cosekey_new;
export const coserecipient_new = __vite__wasmModule.coserecipient_new;
export const headermap_content_type = __vite__wasmModule.headermap_content_type;
export const labels_new = __vite__wasmModule.labels_new;
export const cosesignatures_new = __vite__wasmModule.cosesignatures_new;
export const headermap_set_init_vector = __vite__wasmModule.headermap_set_init_vector;
export const __wbg_coserecipient_free = __vite__wasmModule.__wbg_coserecipient_free;
export const labels_len = __vite__wasmModule.labels_len;
export const cosesignatures_len = __vite__wasmModule.cosesignatures_len;
export const __wbg_countersignature_free = __vite__wasmModule.__wbg_countersignature_free;
export const cosesignature_headers = __vite__wasmModule.cosesignature_headers;
export const cosesign_headers = __vite__wasmModule.cosesign_headers;
export const cosesign1_headers = __vite__wasmModule.cosesign1_headers;
export const coseencrypt_headers = __vite__wasmModule.coseencrypt_headers;
export const coserecipient_headers = __vite__wasmModule.coserecipient_headers;
export const cosesign_payload = __vite__wasmModule.cosesign_payload;
export const cosesign1_payload = __vite__wasmModule.cosesign1_payload;
export const coseencrypt_ciphertext = __vite__wasmModule.coseencrypt_ciphertext;
export const coserecipient_ciphertext = __vite__wasmModule.coserecipient_ciphertext;
export const headermap_init_vector = __vite__wasmModule.headermap_init_vector;
export const headermap_set_content_type = __vite__wasmModule.headermap_set_content_type;
export const __wbg_taggedcbor_free = __vite__wasmModule.__wbg_taggedcbor_free;
export const taggedcbor_to_bytes = __vite__wasmModule.taggedcbor_to_bytes;
export const taggedcbor_from_bytes = __vite__wasmModule.taggedcbor_from_bytes;
export const taggedcbor_tag = __vite__wasmModule.taggedcbor_tag;
export const taggedcbor_value = __vite__wasmModule.taggedcbor_value;
export const taggedcbor_new = __vite__wasmModule.taggedcbor_new;
export const __wbg_cborarray_free = __vite__wasmModule.__wbg_cborarray_free;
export const cborarray_to_bytes = __vite__wasmModule.cborarray_to_bytes;
export const cborarray_from_bytes = __vite__wasmModule.cborarray_from_bytes;
export const cborarray_new = __vite__wasmModule.cborarray_new;
export const cborarray_len = __vite__wasmModule.cborarray_len;
export const cborarray_get = __vite__wasmModule.cborarray_get;
export const cborarray_add = __vite__wasmModule.cborarray_add;
export const cborarray_set_definite_encoding = __vite__wasmModule.cborarray_set_definite_encoding;
export const cborarray_is_definite = __vite__wasmModule.cborarray_is_definite;
export const __wbg_cborobject_free = __vite__wasmModule.__wbg_cborobject_free;
export const cborobject_to_bytes = __vite__wasmModule.cborobject_to_bytes;
export const cborobject_from_bytes = __vite__wasmModule.cborobject_from_bytes;
export const cborobject_new = __vite__wasmModule.cborobject_new;
export const cborobject_len = __vite__wasmModule.cborobject_len;
export const cborobject_insert = __vite__wasmModule.cborobject_insert;
export const cborobject_get = __vite__wasmModule.cborobject_get;
export const cborobject_keys = __vite__wasmModule.cborobject_keys;
export const cborobject_set_definite_encoding = __vite__wasmModule.cborobject_set_definite_encoding;
export const cborobject_is_definite = __vite__wasmModule.cborobject_is_definite;
export const __wbg_cborspecial_free = __vite__wasmModule.__wbg_cborspecial_free;
export const cborspecial_to_bytes = __vite__wasmModule.cborspecial_to_bytes;
export const cborspecial_from_bytes = __vite__wasmModule.cborspecial_from_bytes;
export const cborspecial_new_bool = __vite__wasmModule.cborspecial_new_bool;
export const cborspecial_new_unassigned = __vite__wasmModule.cborspecial_new_unassigned;
export const cborspecial_new_break = __vite__wasmModule.cborspecial_new_break;
export const cborspecial_new_null = __vite__wasmModule.cborspecial_new_null;
export const cborspecial_new_undefined = __vite__wasmModule.cborspecial_new_undefined;
export const cborspecial_kind = __vite__wasmModule.cborspecial_kind;
export const cborspecial_as_bool = __vite__wasmModule.cborspecial_as_bool;
export const cborspecial_as_float = __vite__wasmModule.cborspecial_as_float;
export const cborspecial_as_unassigned = __vite__wasmModule.cborspecial_as_unassigned;
export const __wbg_cborvalue_free = __vite__wasmModule.__wbg_cborvalue_free;
export const cborvalue_to_bytes = __vite__wasmModule.cborvalue_to_bytes;
export const cborvalue_from_bytes = __vite__wasmModule.cborvalue_from_bytes;
export const cborvalue_new_int = __vite__wasmModule.cborvalue_new_int;
export const cborvalue_new_bytes = __vite__wasmModule.cborvalue_new_bytes;
export const cborvalue_new_text = __vite__wasmModule.cborvalue_new_text;
export const cborvalue_new_array = __vite__wasmModule.cborvalue_new_array;
export const cborvalue_new_object = __vite__wasmModule.cborvalue_new_object;
export const cborvalue_new_tagged = __vite__wasmModule.cborvalue_new_tagged;
export const cborvalue_new_special = __vite__wasmModule.cborvalue_new_special;
export const cborvalue_from_label = __vite__wasmModule.cborvalue_from_label;
export const cborvalue_kind = __vite__wasmModule.cborvalue_kind;
export const cborvalue_as_int = __vite__wasmModule.cborvalue_as_int;
export const cborvalue_as_bytes = __vite__wasmModule.cborvalue_as_bytes;
export const cborvalue_as_text = __vite__wasmModule.cborvalue_as_text;
export const cborvalue_as_array = __vite__wasmModule.cborvalue_as_array;
export const cborvalue_as_object = __vite__wasmModule.cborvalue_as_object;
export const cborvalue_as_tagged = __vite__wasmModule.cborvalue_as_tagged;
export const cborvalue_as_special = __vite__wasmModule.cborvalue_as_special;
export const __wbg_cosesign1builder_free = __vite__wasmModule.__wbg_cosesign1builder_free;
export const cosesign1builder_new = __vite__wasmModule.cosesign1builder_new;
export const cosesign1builder_hash_payload = __vite__wasmModule.cosesign1builder_hash_payload;
export const cosesign1builder_set_external_aad = __vite__wasmModule.cosesign1builder_set_external_aad;
export const cosesign1builder_make_data_to_sign = __vite__wasmModule.cosesign1builder_make_data_to_sign;
export const cosesign1builder_build = __vite__wasmModule.cosesign1builder_build;
export const cosesignbuilder_new = __vite__wasmModule.cosesignbuilder_new;
export const cosesignbuilder_make_data_to_sign = __vite__wasmModule.cosesignbuilder_make_data_to_sign;
export const cosesignbuilder_build = __vite__wasmModule.cosesignbuilder_build;
export const __wbg_eddsa25519key_free = __vite__wasmModule.__wbg_eddsa25519key_free;
export const eddsa25519key_new = __vite__wasmModule.eddsa25519key_new;
export const eddsa25519key_set_private_key = __vite__wasmModule.eddsa25519key_set_private_key;
export const eddsa25519key_is_for_signing = __vite__wasmModule.eddsa25519key_is_for_signing;
export const eddsa25519key_is_for_verifying = __vite__wasmModule.eddsa25519key_is_for_verifying;
export const eddsa25519key_build = __vite__wasmModule.eddsa25519key_build;
export const __wbg_cosesignbuilder_free = __vite__wasmModule.__wbg_cosesignbuilder_free;
export const cosesignbuilder_hash_payload = __vite__wasmModule.cosesignbuilder_hash_payload;
export const cosesignbuilder_set_external_aad = __vite__wasmModule.cosesignbuilder_set_external_aad;
export const __wbg_bignum_free = __vite__wasmModule.__wbg_bignum_free;
export const bignum_to_bytes = __vite__wasmModule.bignum_to_bytes;
export const bignum_from_bytes = __vite__wasmModule.bignum_from_bytes;
export const bignum_from_str = __vite__wasmModule.bignum_from_str;
export const bignum_to_str = __vite__wasmModule.bignum_to_str;
export const bignum_checked_mul = __vite__wasmModule.bignum_checked_mul;
export const bignum_checked_add = __vite__wasmModule.bignum_checked_add;
export const bignum_checked_sub = __vite__wasmModule.bignum_checked_sub;
export const __wbg_int_free = __vite__wasmModule.__wbg_int_free;
export const int_new = __vite__wasmModule.int_new;
export const int_new_negative = __vite__wasmModule.int_new_negative;
export const int_new_i32 = __vite__wasmModule.int_new_i32;
export const int_is_positive = __vite__wasmModule.int_is_positive;
export const int_as_positive = __vite__wasmModule.int_as_positive;
export const int_as_negative = __vite__wasmModule.int_as_negative;
export const int_as_i32 = __vite__wasmModule.int_as_i32;
export const __wbindgen_malloc = __vite__wasmModule.__wbindgen_malloc;
export const __wbindgen_realloc = __vite__wasmModule.__wbindgen_realloc;
export const __wbindgen_add_to_stack_pointer = __vite__wasmModule.__wbindgen_add_to_stack_pointer;
export const __wbindgen_free = __vite__wasmModule.__wbindgen_free;
